import React from "react";

type BaseModalProps = {
  modalTitle?: string;
  onCloseClick: () => void;
  onBackNavigationClick?: () => void;
  buttons: Array<{
    text: string;
    onClick: () => void;
  }>;
} & React.PropsWithChildren;

export const BaseModal = ({
  modalTitle,
  onCloseClick,
  onBackNavigationClick,
  children,
  buttons,
}: BaseModalProps) => {
  return (
    <div
      className="modal show d-block"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered d-flex">
        <div className="modal-content">
          <div className="modal-header">
            {onBackNavigationClick && (
              <button
                type="button"
                className="btn-back me-auto"
                aria-label="Zurück"
                onClick={onBackNavigationClick}
              ></button>
            )}
            {!onBackNavigationClick && <span className="me-auto" />}
            {modalTitle && (
              <strong className="modal-title">{modalTitle}</strong>
            )}
            <button
              type="button"
              className="btn-close"
              aria-label="Schließen"
              onClick={onCloseClick}
            ></button>
          </div>
          {children && <div className="modal-body">{children}</div>}
          <div className="modal-footer">
            {buttons.map(({ text, onClick }) => (
              <button
                type="button"
                className="btn btn-info col"
                key={text}
                onClick={onClick}
              >
                {text}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
